import { parse } from 'cookie'

export interface ConfluenceOauthSuccessPayload {
  CONFLUENCE_ACCESS_TOKEN: string
  CONFLUENCE_REFRESH_TOKEN: string
  CONFLUENCE_SCOPE: string
}

export interface GoogleOauthSuccessPayload {
  GOOGLE_ACCESS_TOKEN: string
}

export interface OauthFailurePayload {
  error: string
}

type OauthPayload = ConfluenceOauthSuccessPayload | GoogleOauthSuccessPayload | OauthFailurePayload

const oauthWindowConfig = {
  width: 600,
  height: 800,
  toolbar: 0,
  scrollbars: 1,
  status: 1,
  resizable: 1,
  location: 1,
  menuBar: 0,
}

export const isOauthNeeded = async (serviceName: string): Promise<boolean> => {
  let accessToken = null
  let refreshToken = null
  let oauthNeeded = false

  if (serviceName === 'CONFLUENCE') {
    accessToken = parse(document.cookie).CONFLUENCE_ACCESS_TOKEN
    refreshToken = parse(document.cookie).CONFLUENCE_ACCESS_TOKEN
    oauthNeeded = true && !(accessToken && refreshToken)
  }

  if (serviceName === 'GOOGLE') {
    accessToken = parse(document.cookie).GOOGLE_ACCESS_TOKEN
    const res = await fetch('https://www.googleapis.com/drive/v3/about?fields=*', {
      method: 'GET',
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    const resJson = await res.json()

    const { error } = resJson
    oauthNeeded = true && !!error
  }

  return oauthNeeded
}

export const openOauthWindow = (url: string): Promise<OauthPayload | null> => {
  const left = Math.floor(window.screenX + (window.outerWidth - oauthWindowConfig.width) / 2)
  const top = Math.floor(window.screenY + (window.outerHeight - oauthWindowConfig.height) / 8)

  const options = Object.entries({ ...oauthWindowConfig, left, top })
    .map(([key, value]) => `${key}=${value}`)
    .join(',')

  const authWindow = window.open(url, '', options)

  // Create IE + others compatible event handler
  const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent'
  const eventer = window[eventMethod]
  const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message'

  // Listen to message from child window
  const authPromise: Promise<OauthPayload> = new Promise((resolve) => {
    eventer(
      messageEvent,
      (e) => {
        if (e.origin !== window.location.origin) {
          authWindow.close()
          resolve(e.data.payload)
        }

        if (e.data.payload) {
          resolve(e.data.payload)
          authWindow.close()
        }
      },
      false
    )
  })

  return authPromise
}
